import { ROUTE_NAMES_LEGACY_JSD_CUSTOMERS } from '@atlassian/jira-common-constants/src/spa-routes.tsx';

export const legacyJsdCustomersRoute = {
	name: ROUTE_NAMES_LEGACY_JSD_CUSTOMERS,
	path: '/projects/:projectKey/customers',
};
